import { Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import type { ReactNode } from 'react'

type NectarTaskProgressProps = {
  completed: number
  total: number
  rightSlot?: ReactNode
}

export const NectarTaskProgress = ({ completed, total, rightSlot }: NectarTaskProgressProps) => {
  const safeTotal = Math.max(total, 1)
  const safeCompleted = Math.max(0, Math.min(completed, safeTotal))
  const pct = Math.round((safeCompleted / safeTotal) * 100)
  const currentIndex = Math.min(safeCompleted + 1, safeTotal)

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between gap-3">
        <Text className="text-gray-80">
          <Trans>
            Task {currentIndex} of {safeTotal}
          </Trans>
        </Text>
        {rightSlot}
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-gray-100">
        <div
          className="bg-green h-full rounded-full transition-all duration-500 ease-out"
          style={{
            width: `${pct}%`,
            boxShadow: pct > 0 ? '0 0 8px var(--color-green)' : 'none'
          }}
        />
      </div>
    </div>
  )
}
